import { HttpParams } from "@angular/common/http";

export function isTouchDevice(): boolean {
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator['msMaxTouchPoints'] > 0));
}


export function httpParam(params: HttpParams, param: string, value: string | number): HttpParams {
  if (!!value) {
    return params.set(param, value.toString());
  }
  return params;
}


export let trace: Function = function (...lets) { };
if (window.location.hostname.indexOf('app.spryng.io') === -1) {
  // Only enable trace support if we are not on app.spryng.io
  if (typeof console === 'object' && typeof console.log === 'function') {
    trace = function (...lets) {
      return lets.map((msg) => console.log(msg));
    };
  } else {
    trace = function (...lets) { };
  }
}


export function getOppositeColor(hexColor) {
  // Remove the # symbol if it exists
  hexColor = hexColor.replace("#", "");

  // Convert the hex color to RGB
  var red = parseInt(hexColor.substr(0, 2), 16);
  var green = parseInt(hexColor.substr(2, 2), 16);
  var blue = parseInt(hexColor.substr(4, 2), 16);

  // Calculate the opposite color
  var oppositeRed = 255 - red;
  var oppositeGreen = 255 - green;
  var oppositeBlue = 255 - blue;

  // Convert the opposite color back to hex
  var oppositeHexColor = "#" +
    ("0" + oppositeRed.toString(16)).slice(-2) +
    ("0" + oppositeGreen.toString(16)).slice(-2) +
    ("0" + oppositeBlue.toString(16)).slice(-2);

  return oppositeHexColor;
}
